<script setup>
import {computed, ref, watch} from 'vue';

const props = defineProps({
   customClass: {
       type: String,
       required: false,
       default: 'bg-gray-4',
   },
    uploadPercentage: [String, Number],
});

const percentage = computed(() => props.uploadPercentage + '%');

</script>

<template>
    <div :class="['h-2 relative overflow-hidden rounded-full', customClass]">
        <div class="bg-primary-1 absolute top-0 left-0 h-full transition-all" :style="{ width: percentage }"></div>
    </div>
</template>

<style scoped>

</style>
